import axios from "axios";

export default{
    getPhotoGroups(params){
        return axios.get("photos", {params});
    }
};